import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LayoutPresensi } from './layoutPresensi';
import AbsenManual from '../../componen/presensi/admin/AbsenManual';

export const AbsenManualPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (
   <LayoutPresensi>
    <AbsenManual />
   </LayoutPresensi>

  )
}
